import {isDocumentFileTypeAsset} from './isDocumentFileTypeAsset';
import {isImageFileTypeAsset} from './isImageFileTypeAsset';
import {isMediaFileTypeAsset} from './isMediaFileTypeAsset';
import {isVideoFileTypeAsset} from './isVideoFileTypeAsset';

export const getGeneralAssetFileType = (
	fileFormatFamily: string[] = [],
	specific = false,
) => {
	if (isDocumentFileTypeAsset(fileFormatFamily)) return 'document';
	if (isImageFileTypeAsset(fileFormatFamily)) return 'image';
	if (isMediaFileTypeAsset(fileFormatFamily)) {
		return specific
			? isVideoFileTypeAsset(fileFormatFamily)
				? 'video'
				: 'audio'
			: 'media';
	}
};

export default getGeneralAssetFileType;
